import { createTheme, CssBaseline } from '@mui/material';
import './App.css';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import RoutesComponent from './components/Navigation/Routes';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const theme = createTheme({});
  return (
    <>
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <BrowserRouter>
        <RoutesComponent/>
        <ToastContainer position='top-right' autoClose={3000} />
      </BrowserRouter>
    </ThemeProvider>
    </>
  );
}

export default App;
